<script lang="ts">
  import { cn } from '$lib/utils';

  let className = '';
  export { className as class };
</script>

<div class={cn('skeleton-loading', className)} />

<style lang="postcss">
  @keyframes skeleton-loading {
    0% {
      background-position: 0% 200%;
    }

    100% {
      background-position: 0% 0%;
    }
  }

  .skeleton-loading {
    background-image: linear-gradient(
      hsl(var(--color-grey-12) / 0.04),
      hsl(var(--color-grey-12) / 0.02),
      hsl(var(--color-grey-12) / 0.04)
    );
    background-size: 100% 200%;
    animation: skeleton-loading 2s linear infinite;
  }
</style>
